/** 
    .env: Default.
    .env.local: Local overrides. This file is loaded for all environments except test.
    .env.development, .env.test, .env.production: Environment-specific settings.
    .env.development.local, .env.test.local, .env.production.local: Local overrides of environment-specific settings
Example:: 
    REACT_APP_VERSION=$npm_package_version
    REACT_APP_NAME=Advanced Customer List Generator
*/


const Token = "";

const globalAppAccess = {
    code: ['XAZ_AZAP_FXHUB_PUB_APPS'],
    appListName:['CC', 'CAR']
};

export const ENV_LIST = {
    dev: {
        APP_BASE_URL: "https://dev.fxhub.astrazeneca.com",
        API_END_POINT: "https://beta-api-dev.azap.astrazeneca.com",
        GENERIC_API: "https://dev-genericapi.fxhub.astrazeneca.com/generic",
        CONTENT_API_PATH: 'https://eu-nprd.connect.astrazeneca.com/api/dv-exp-content-library/1',
        API_URL: 'https://us-nprd.connect.astrazeneca.com/api/dv-sys-powerx-ui/1/direct-query',
        envGroupName:'UAT'
    },
    test: {
        API_END_POINT: "https://beta-api-test.azap.astrazeneca.com",
        APP_BASE_URL: "https://test.fxhub.astrazeneca.com",
        GENERIC_API: "https://test-genericapi.fxhub.astrazeneca.com/generic",
        CONTENT_API_PATH: 'https://eu-nprd.connect.astrazeneca.com/api/ts-exp-content-library/1',
        API_URL: "https://us-nprd.connect.astrazeneca.com/api/ts-sys-powerx-ui/1/direct-query",
        envGroupName:'UAT'

    },
    poc: {
        API_END_POINT: "https://beta-api-dev.azap.astrazeneca.com",
        APP_BASE_URL: "https://poc.fxhub.astrazeneca.com",
        GENERIC_API: "https://poc-genericapi.fxhub.astrazeneca.com/generic",
        CONTENT_API_PATH: 'https://eu-nprd.connect.astrazeneca.com/api/ts-exp-content-library/1',
        API_URL: "https://us-nprd.connect.astrazeneca.com/api/ts-sys-powerx-ui/1/direct-query",
        envGroupName:'UAT'

    },
    uat: {
        API_END_POINT: "https://ss-api-uat.azap.astrazeneca.com",
        APP_BASE_URL: "https://uat.fxhub.astrazeneca.com",
        GENERIC_API: "https://uat-genericapi.fxhub.astrazeneca.com/generic",
        CONTENT_API_PATH: 'https://eu-nprd.connect.astrazeneca.com/api/ut-exp-content-library/1',
        API_URL: "https://us-nprd.connect.astrazeneca.com/api/ut-sys-powerx-ui/1/direct-query",
        envGroupName:'UAT'

    },
    prod: {
        baseName: "",
        API_END_POINT: "https://ss-api.azap.astrazeneca.com",
        GENERIC_API: "https://genericapi.fxhub.astrazeneca.com/generic",
        APP_BASE_URL: "https://fxhub.astrazeneca.com",
        azapUrl: "https://azap.astrazeneca.com",
        API_URL: "https://us-prd.connect.astrazeneca.com/api/sys-powerx-ui/1/direct-query",
        globalAppAccess,
        
    }
};

// define the default dev as local env,
//this line for local environments only:
ENV_LIST.local =  ENV_LIST['test']; 

const CURRENT_ENV ='test'// process.env.REACT_APP_ENV || 'dev'; // local | dev | test | uat | prod 
const ENV_CONFIG = ENV_LIST[CURRENT_ENV];
export const APPName  = 'FXHUB Home';
export const AppEnv =  CURRENT_ENV
export const BaseURL = ENV_CONFIG.APP_BASE_URL;
export const TableAPIURL = ENV_CONFIG.API_URL;

//API ENDPOINT URL
export const ApiBaseURL = ENV_CONFIG.API_END_POINT;
export const GenericApiBaseURL = ENV_CONFIG.GENERIC_API;
export const CENTENT_API_PATH = ENV_CONFIG.CONTENT_API_PATH;
export const CLIENT_API_APTH = ENV_CONFIG.APP_API_APTH;

export const CurrentEnvGroupName = ENV_CONFIG.envGroupName;


// for REACT ROUTER BASE NAME
export const BaseName = (CURRENT_ENV === 'local') ? '/' : process.env.PUBLIC_URL;
//microsoft doc viewer
export const DOCPreviewURL ='https://view.officeapps.live.com/op/embed.aspx?src=';

// for local env only
export const Auth = {
    "firstName": "",
    "lastName": "",
    "userName": "",
    "fullName": "",
    "email": "",
    "memberOf": "",
    "countryCode": "",
    "jobTtile":"",
    "token": Token,
    "env": ""
}
